import Typography from '@mui/material/Typography';
import CustomizedAccordions from "../components/CustomAccordion";

function Writing(){
    return(
        <>
            <Typography variant="body1" color="white" sx={{mb:2}}>
                Questi non sono racconti veri e propri, sono piuttosto delle bozze scritte nelle pause al lavoro quando mi annoio.
                Caricherò storie e racconti scritti con più cura nelle prossime settimane.
            </Typography>
            <CustomizedAccordions folder="writing" showLength={false}/>
        </>
    )
}
export default Writing;